import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { cn } from "@/lib/utils";
import { ImagePlus, Send } from "lucide-react";
import { RefObject, useRef } from "react";
type Props = {
  setValue: (value: string) => void;
  value: string;
  isSendingMessage?: boolean;
  inputRef?: RefObject<HTMLInputElement>;
  disabled?: boolean;
  /** Enable send even with empty text (e.g. images attached). */
  hasAttachments?: boolean;
  /** Called with the picked image files. Omit to hide the attach button. */
  onPickImages?: (files: FileList) => void;
};
export function SubmitInput({
  setValue,
  value,
  isSendingMessage,
  inputRef,
  disabled,
  hasAttachments,
  onPickImages
}: Props) {
  const fileInputRef = useRef<HTMLInputElement>(null);
  const canSend = !disabled && !isSendingMessage && (value.trim() !== "" || !!hasAttachments);
  return <div className="flex items-center gap-2" data-sentry-component="SubmitInput" data-sentry-source-file="SubmitInput.tsx">
      {onPickImages && <>
          <input ref={fileInputRef} type="file" accept="image/*" multiple className="hidden" onChange={e => {
        if (e.target.files?.length) onPickImages(e.target.files);
        e.target.value = "";
      }} />
          <Button type="button" variant="ghost" size="icon" disabled={disabled} tabIndex={-1} onMouseDown={e => e.preventDefault()} onClick={() => fileInputRef.current?.click()} className="h-11 w-9 shrink-0 rounded-full text-faint-foreground hover:text-foreground md:-ml-2">
            <ImagePlus />
          </Button>
        </>}
      <div className="relative flex-1">
        <Input ref={inputRef} onChange={e => setValue(e.target.value)} type="text" value={value} placeholder={`Escreva uma mensagem...`} className="w-full p-2 pl-5 h-11 border rounded-3xl bg-muted/50 backdrop-blur-xl pr-16! focus-visible:ring-0 md:focus-visible:ring-[3px]" data-sentry-element="Input" data-sentry-source-file="SubmitInput.tsx" />
        <Button disabled={!canSend} isLoading={isSendingMessage} className={cn("rounded-full absolute right-1.5 top-1/2 -translate-y-1/2 disabled:bg-zinc-900 disabled:border disabled:shadow-xs", disabled && "opacity-50 cursor-not-allowed")} type={"submit"} variant="simpleDark" tabIndex={-1} onMouseDown={e => e.preventDefault()} onTouchStart={e => {
        e.preventDefault();
      }} data-sentry-element="Button" data-sentry-source-file="SubmitInput.tsx">
          <Send data-sentry-element="Send" data-sentry-source-file="SubmitInput.tsx" />
        </Button>
      </div>
    </div>;
}